'use strict';

cart.$inject = ["CartSeller", "CartDisabledSeller", "Totals"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cart = cart;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cart(CartSeller, CartDisabledSeller, Totals) {
    var clazz = function Cart() {
        var defaults = {
            sellers: [],
            disabledSellers: [],
            totals: null,
            canCheckout: false,
            isEmpty: true,
            totalPriceDiscounts: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, products) {
            var _this = this;

            products.forEach(function (product) {
                var productAndSeller = _this.getProductAndSeller(product.id, product.discountId);
                if (!productAndSeller.product) {
                    return;
                }

                productAndSeller.seller.updateAfterSetQuantity(updatedCart, product);
                productAndSeller.product.updateAfterSetQuantity(updatedCart, product);
            });

            this.totals.updateAfterSetQuantity(updatedCart.totals);
            this.isEmpty = !this.sellers || this.sellers.length <= 0;
            this.canCheckout = updatedCart.canCheckout;
        },

        updateAfterRemove: function updateAfterRemove(updatedCart, sellerId, product) {
            var sellerToUpdate = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerToUpdate) {
                return;
            }

            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return s.id === sellerId;
            });
            if (sellerInUpdatedCart) {
                sellerToUpdate.updateAfterRemove(sellerInUpdatedCart, product);
            } else {
                _lodash2.default.remove(this.sellers, function (s) {
                    return s.id === sellerId;
                });
            }

            this.totals.updateAfterSetQuantity(updatedCart.totals);
            this.isEmpty = !this.sellers || this.sellers.length <= 0;
            this.canCheckout = updatedCart.canCheckout;
        },

        setFocusOnProduct: function setFocusOnProduct(productId) {
            if (!productId) {
                return;
            }

            productId = parseInt(productId);

            var seller = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === productId;
                });
            });
            if (!seller) {
                return;
            }

            var product = _lodash2.default.find(seller.products, function (p) {
                return p.id === productId;
            });
            if (!product) {
                return;
            }

            product.hasFocus = true;
        },

        isProductInCart: function isProductInCart(product) {
            return _lodash2.default.some(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id || p.discountId === product.discountId;
                });
            });
        },

        getProductQuantity: function getProductQuantity(productId, discountId) {
            var productAndSeller = this.getProductAndSeller(productId, discountId);
            return productAndSeller.product ? productAndSeller.product.quantity : 0;
        },

        getIncludedProductQuantity: function getIncludedProductQuantity(parentProduct, includedProduct) {
            var productAndSeller = this.getProductAndSeller(parentProduct.id, parentProduct.discountId);
            if (!productAndSeller.product) {
                return 0;
            }

            var incProduct = _lodash2.default.find(productAndSeller.product.included_products, function (i) {
                return i.id === includedProduct.id;
            });
            return incProduct ? incProduct.quantity : 0;
        },

        getProductAndSeller: function getProductAndSeller(productId, discountId) {
            var seller = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === productId && (p.discountId || 0) === (discountId || 0);
                });
            });
            if (!seller) {
                return { seller: null, product: null };
            }

            var product = _lodash2.default.find(seller.products, function (p) {
                return p.id === productId && (p.discountId || 0) === (discountId || 0);
            });
            return { seller: seller, product: product };
        },

        getPanaceeProductInCart: function getPanaceeProductInCart(productId, discountId) {
            var productAndSeller = this.getProductAndSeller(productId, discountId);
            if (!productAndSeller.product) {
                return null;
            }

            return productAndSeller.product;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.sellers = _lodash2.default.map(resource.sellers, function (i) {
            return CartSeller.create(i, resource.products);
        });
        o.disabledSellers = _lodash2.default.map(resource.disabledSellers, function (i) {
            return CartDisabledSeller.create(i, resource.products);
        });
        o.totals = Totals.create(resource);
        o.canCheckout = resource.canCheckout;
        o.isEmpty = !o.sellers || o.sellers.length <= 0;
        o.errors = resource.errorMessages;
        o.totalPriceDiscounts = resource.totalPriceDiscounts;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.errors = resource.errorMessages;
        o.sellers = _lodash2.default.map(resource.sellers, function (i) {
            return CartSeller.createFromLocalStorage(i);
        });
        o.disabledSellers = _lodash2.default.map(resource.disabledSellers, function (i) {
            return CartDisabledSeller.createFromLocalStorage(i);
        });
        o.totals = Totals.createFromLocalStorage(resource);
        o.canCheckout = resource.canCheckout;
        o.isEmpty = !o.sellers || o.sellers.length <= 0;
        o.totalPriceDiscounts = resource.totalPriceDiscounts;
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartModel.js
// module id = 733
// module chunks = 0